import { Parallax } from 'react-scroll-parallax';
import { motion } from 'framer-motion';

const ParallaxElements = () => {
  return (
    <>
      {/* Floating shapes with parallax */}
      <Parallax
        translateY={[0, -50]}
        className="absolute top-20 left-10 w-64 h-64 opacity-70"
      >
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 5, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="w-full h-full rounded-full bg-gradient-to-r from-blue-400/20 to-green-400/20 blur-2xl"
        />
      </Parallax>

      <Parallax
        translateY={[0, 50]}
        className="absolute bottom-20 right-10 w-72 h-72 opacity-70"
      >
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, -5, 0],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="w-full h-full rounded-full bg-gradient-to-r from-amber-400/20 to-blue-400/20 blur-2xl"
        />
      </Parallax>

      {/* Floating icons with parallax */}
      <Parallax
        translateY={[-20, 20]}
        scale={[0.8, 1.2]}
        rotate={[-10, 10]}
        className="absolute top-1/4 left-1/4 text-blue-500/20 text-6xl"
      >
        <div className="w-16 h-16 rounded-lg bg-blue-500/10 backdrop-blur-sm" />
      </Parallax>

      <Parallax
        translateY={[20, -20]}
        scale={[1.2, 0.8]}
        rotate={[10, -10]}
        className="absolute bottom-1/4 right-1/4 text-green-500/20 text-6xl"
      >
        <div className="w-16 h-16 rounded-lg bg-green-500/10 backdrop-blur-sm" />
      </Parallax>
    </>
  );
};

export default ParallaxElements;
